// extracted by mini-css-extract-plugin
export default {"tag":"MC8zGfd","tag--default":"l9ivdkB","tag--disabled":"Hx5rfo0","tag--lime":"T7H6pDg","tag__button":"M3bKdVQ","tag__icon":"pHgIkBA"};